'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-13d783d6.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var CartIcon = function (props) { return (
React__default['default'].createElement("svg", tslib_es6.__assign({ viewBox: "0 0 30 30", height: "30", width: "30", fill: "currentColor" }, props),
    React__default['default'].createElement("path", { d: "M15 7a3 3 0 0 1 2.995 2.824L18 10h5v13H7V10h5a3 3 0 0 1 3-3zm7.111 3.893H7.89V22.12H22.11V10.893zM15 7.891c-1.53 0-2.107 1.28-2.107 2.109h4.223c0-.828-.586-2.11-2.116-2.11z", fillRule: "evenodd" }))); };

exports.default = CartIcon;
//# sourceMappingURL=index.js.map
